import React from 'react';
import { contactoData } from '../data/mock';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

const Contacto = () => {
  const { lat, lng } = contactoData.coordenadas;
  
  // URL para embed de OpenStreetMap
  const mapUrl = `https://www.openstreetmap.org/export/embed.html?bbox=${lng - 0.01},${lat - 0.005},${lng + 0.01},${lat + 0.005}&layer=mapnik&marker=${lat},${lng}`;
  
  // URL para abrir en mapa completo
  const mapLinkUrl = `https://www.openstreetmap.org/?mlat=${lat}&mlon=${lng}#map=16/${lat}/${lng}`;

  return (
    <section id="contacto" className="py-16 lg:py-24 bg-gray-50">
      <div className="container mx-auto px-6 lg:px-10 max-w-7xl">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
            Contacte con nosotros
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          {/* Contact Info */}
          <div className="space-y-5">
            {/* Phone */}
            <div className="flex items-start gap-4 p-5 bg-white rounded-xl border border-gray-100 hover:shadow-md transition-shadow">
              <div className="p-3 bg-[#0d3b66]/10 rounded-lg">
                <Phone className="text-[#0d3b66]" size={24} />
              </div>
              <div>
                <a 
                  href={`tel:${contactoData.telefono.replace(/\s/g, '')}`}
                  className="text-[#0d3b66] hover:underline text-xl font-semibold block"
                >
                  {contactoData.telefono}
                </a>
                <div className="flex items-center gap-2 mt-1 text-gray-500">
                  <Clock size={14} />
                  <span className="text-sm">{contactoData.horario}</span>
                </div>
              </div>
            </div>

            {/* Email */}
            <div className="flex items-start gap-4 p-5 bg-white rounded-xl border border-gray-100 hover:shadow-md transition-shadow">
              <div className="p-3 bg-[#0d3b66]/10 rounded-lg">
                <Mail className="text-[#0d3b66]" size={24} />
              </div>
              <div>
                <a 
                  href={`mailto:${contactoData.email}`}
                  className="text-[#0d3b66] hover:underline text-xl font-semibold block"
                >
                  {contactoData.email}
                </a>
                <p className="text-gray-500 text-sm mt-1">
                  {contactoData.tiempoRespuesta}
                </p>
              </div>
            </div>

            {/* Address */}
            <div className="flex items-start gap-4 p-5 bg-white rounded-xl border border-gray-100 hover:shadow-md transition-shadow">
              <div className="p-3 bg-[#0d3b66]/10 rounded-lg">
                <MapPin className="text-[#0d3b66]" size={24} />
              </div>
              <div>
                <p className="text-gray-900 font-semibold text-lg">
                  {contactoData.direccion}
                </p>
                <p className="text-gray-500 text-sm mt-1">
                  {contactoData.codigoPostal}
                </p>
              </div>
            </div>
          </div>

          {/* Map */}
          <div className="relative rounded-xl overflow-hidden border border-gray-200 h-[350px] lg:h-full min-h-[350px] shadow-md">
            <iframe
              title="Ubicación Micro-Bat"
              src={mapUrl}
              className="w-full h-full"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
            {/* Link to open in new tab */}
            <a
              href={mapLinkUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="absolute bottom-4 right-4 btn-primary text-sm py-2 px-4"
            >
              Ver mapa completo
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contacto;
